import React from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Login from "components/auth/Login";

const LoginDialog = ({ isOpen, handleClose, fullScreen = false }) => {
  return (
    <Dialog fullScreen={fullScreen} open={isOpen} onClose={handleClose}>
      <DialogContent>
        <Login onClose={handleClose} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          Փակել
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginDialog;
